/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { typography, fontWeights } from '../../../../styles/typography';
import { MediaQueries } from '../../../../styles/Grid';

export const wrapper = css({
  backgroundColor: colorsPalette.brown10,
  padding: 32,
});

export const title = css(typography.effra28, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,

  [MediaQueries.md]: {
    ...typography.effra40,
    fontWeight: fontWeights.medium,
  },

  [MediaQueries.xl]: {
    ...typography.effra40,
    fontWeight: fontWeights.medium,
  },
});

export const description = css(typography.effra18, {
  color: colorsPalette.grey80,
  marginTop: 16,
});

export const descriptionSecondary = css({
  color: colorsPalette.black,
});

export const suggestion = css({
  color: colorsPalette.black,
});

export const contactBlock = css({
  marginTop: 32,

  [MediaQueries.md]: {
    alignItems: 'center',
    display: 'flex',
  },

  [MediaQueries.xl]: {
    alignItems: 'center',
    display: 'flex',
  },
});

export const contactBtn = css({
  [MediaQueries.md]: {
    paddingLeft: 40,
    paddingRight: 40,
    width: 'auto',
  },

  [MediaQueries.xl]: {
    paddingLeft: 40,
    paddingRight: 40,
    width: 'auto',
  },
});

export const callUsBlock = css(typography.effra14, {
  display: 'flex',
  justifyContent: 'center',
  marginTop: 16,

  [MediaQueries.md]: {
    ...typography.effra16,
    marginLeft: 25,
    marginTop: 0,
  },

  [MediaQueries.xl]: {
    ...typography.effra16,
    marginLeft: 25,
    marginTop: 0,
  },

  '.phone-container': {
    alignItems: 'center',
    justifyContent: 'center',
  },
});
